export function getValues<T extends Record<string, unknown>>(obj: T) {
  return Object.values(obj) as [(typeof obj)[keyof T]];
}

export const EntityType = {
  Lot: 'Lot',
  Organization: 'Organization',
  Vendor: 'Vendor',
  Venue: 'Venue',
} as const;

export const PermissionType = {
  Admin: 'Admin',
  Editor: 'Editor',
  Viewer: 'Viewer',
  None: 'None',
} as const;

export const PermissionTypeInt = {
  Admin: 3,
  Editor: 1,
  Viewer: 2,
  None: 0,
} as const;

export enum CommissionStructure {
  consumer = 'consumer',
  vendor = 'vendor',
}

export const OrganizationTypes = {
  Event: 'Event',
  Vendor: 'Vendor',
  Unspecified: 'Unspecified',
  UnspecifiedDivision: 'Unspecified-Division',
} as const;

export type OrganizationType =
  (typeof OrganizationTypes)[keyof typeof OrganizationTypes];

export enum PayoutInterval {
  Daily = '1',
  Weekly = '2',
  Monthly = '3',
}
export enum UserRole {
  Anonymous = 'Anonymous',
  User = 'User',
  SuperAdmin = 'SuperAdmin',
  Manager = 'Manager',
  Employee = 'Employee',
  Owner = 'Owner',
  Accountant = 'Accountant',
  Integration = 'Integration',
  Admin = 'Admin',
  AI = 'AI',
}

export enum UserRoleInts {
  // Anonymous = 'Anonymous',
  User = 2,
  SuperAdmin = 4,
  Manager = 6,
  Employee = 7,
  Owner = 8,
  Accountant = 10,
  Integration = 11,
  Admin = 0,
}

export const DashboardRoles = [
  UserRole.Admin,
  UserRole.Owner,
  UserRole.Accountant,
  UserRole.Manager,
  UserRole.Employee,
  UserRole.SuperAdmin,
];

export enum InvoiceSort {
  PickupTimeAsc = '1',
  PickupTimeDesc = '2',
  TimeCreatedAsc = '3',
  TimeCreatedDesc = '4',
  DueDateAsc = '5',
  DueDateDesc = '6',
  TimeCompletedAsc = '7',
  TimeCompletedDesc = '8',
}

export enum TransactionSort {
  PickupTimeAsc = '1',
  PickupTimeDesc = '2',
  TimeCreatedAsc = '3',
  TimeCreatedDesc = '4',
  TimeCompletedAsc = '7',
  TimeCompletedDesc = '8',
}
